import { BreakpointObserver } from '@angular/cdk/layout';
import {  Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { RESPONSIVE_MOBILE_BREAKPOINT } from '../models/app-constants';
import { Subscription, distinctUntilChanged, pipe, tap } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-water-monitoring',
	templateUrl: './water-monitoring.component.html',
	styleUrls: ['./water-monitoring.component.scss'],
})

export class WaterMonitoringComponent implements OnInit, OnDestroy, AfterViewInit {
	private fragment: string | null;
	currentRoute : string;

	isMobileView : boolean = false;
	mobileMenuExpanded : boolean = false;
	private breakpointSub : Subscription ;
	private routerSub : Subscription ;

	readonly breakpoint$ = this.breakpointObserver.observe(RESPONSIVE_MOBILE_BREAKPOINT).pipe(tap(value => {
       
    }), distinctUntilChanged());

	constructor(private activatedRoute: ActivatedRoute,
		private router : Router,
		private breakpointObserver : BreakpointObserver) 
	{


	}

	ngOnInit(): void {
		this.breakpointSub = this.breakpoint$.subscribe({
            next: (result) => {
				this.isMobileView = result.matches;
				if(!result.matches)
				{
					this.mobileMenuExpanded = false;
				}
            },
            error: (ex) => {

            },
            complete: () => {

            }
        });
		this.listenToRouterEvents();
	}

	private listenToRouterEvents = () => {
		//this.routerSub = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe({
		this.routerSub = this.router.events.subscribe({			
			next : (event : any) => {				
				if(0 < this.activatedRoute.children?.length)
				{
					const sub = this.activatedRoute.children[0].data?.subscribe({
						next : (value) => {
							this.currentRoute = value?.["breadcrumbLabel"]?.toString() ?? "";
						},
						complete : () => {
							sub && sub?.unsubscribe();
						}
					});
				}				
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}});		
	}


	ngOnDestroy(): void {
		this.breakpointSub && this.breakpointSub?.unsubscribe();
		this.routerSub && this.routerSub?.unsubscribe();
	}

	ngAfterViewInit(): void {
		
	}

	onExpandMobileMenuClicked = (event : any) => {
		this.mobileMenuExpanded = !this.mobileMenuExpanded;
	}
	

	// get currentRoute (){
	// 	this.activatedRoute?.children?.[0]?.data?.
	// }
}
